export default __webpack_public_path__ + "static/hexagonal-ee38a487f11fc7b71be6acf2db71027e.png";